export const PREVIEW_LIMITS = {
  STROKE_WIDTH_MIN: 0,
  STROKE_WIDTH_MAX: 6.5,
};
